
import React, { Fragment, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

// Utils

import { getFirstEventEnum } from '@utils/miscellaneous/getVerificationDocumentsConfig';
import { UNSUPPORTED_EVENT } from '@constants/configs/QLEDocumentVerificationConfigs/documentsVerificationConstants';

// Constants

import { checkUserStatus, USER_GROUP_ROLES } from '@constants/roles/userRoleTypes';
import { configs } from '@constants/configs/configs';

// Hooks

import { useExchangeAndProgramNames } from '@reducers/appReducer';


const EventInfo = props => {

    const {
        event,
        eventNotSupported,
        stateCode,
        userRole,
        validationCompleted
    } = props;

    const isSuperUser = useMemo(
        () => checkUserStatus(USER_GROUP_ROLES.SUPERUSERS, userRole),
        [ userRole ]
    );

    const exchangeAndProgramNames = useExchangeAndProgramNames();

    const securedEventName = eventNotSupported ? UNSUPPORTED_EVENT : event;

    const eventLabelValues = { receivedEvent: event, ...exchangeAndProgramNames };

    const getHeader = () => {
        return (
            <div id = 'qle-event-header' className = 'grid-row header'>
                <div className = 'desktop:grid-col-8 tablet:grid-col-8'>
                    <h3 className = 'heading margin-0'>
                        <FormattedMessage
                            id = { `qle.event.${ securedEventName }` }
                            values = { eventLabelValues }
                        />
                    </h3>
                </div>
            </div>
        );
    };

    const attestationFormLinkForNewJersey = (
        <a
            className = 'usa-link--external'
            href = { configs.externalEndpoints.NJ_LINKS.EXCEPTIONAL_CIRCUMSTANCES_ATTESTATION_FORM }
            target = '_blank'
            rel = 'noopener noreferrer'
        >
            <FormattedMessage id = 'qle.attestation_form_link.anchor'/>
        </a>
    );

    return (
        <Fragment>
            { getHeader() }
            {
                !validationCompleted ?

                    <div id = 'qle-introduction' className = 'grid-row'>
                        <FormattedMessage
                            id = { `qle.documents.introduction.${getFirstEventEnum(stateCode, securedEventName)}` }
                            values = {{ link: attestationFormLinkForNewJersey }}
                            tagName="p"
                        />
                    </div> :

                    <div id = 'qle-alert' className = 'grid-row'>
                        <div className = 'usa-alert gi-alert gi-alert__left-accent gi-alert__info'>
                            <div className = 'gi-alert__body'>
                                <p className = 'gi-alert__text'>
                                    <FormattedMessage
                                        id = 'qle.documents.status'
                                        values={{
                                            qle: (
                                                <FormattedMessage
                                                    id = { `qle.event.${ securedEventName }` }
                                                    values = { eventLabelValues }
                                                />
                                            )
                                        }}
                                    />
                                </p>
                                <br/>
                                {
                                    isSuperUser &&

                                    <p className = 'gi-alert__text'>
                                        <FormattedMessage id = 'qle.superusers.ticketed.warning'/>
                                    </p>
                                }
                            </div>
                        </div>
                    </div>
            }
        </Fragment>
    );
};

export default EventInfo;